import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/app-theme.css';
import axios from "axios";
import VueAxios from "vue-axios";
import 'default-passive-events'
import moment from 'moment'
//导入接口地址
import apiCfg from "../config"
import { applyDocumentTitle, ensureSysBrand, getBrand } from "./utils/sysBrand"
import { initAppTheme } from "./utils/appTheme"

initAppTheme()

//将接口地址挂载到Vue上
Vue.prototype.Api = apiCfg.portalApi //客户端api根地址
// 遗留：部分报表/尾程柜仍直连 manager；C 批次待 Portal 代理后移除
Vue.prototype.mApi = apiCfg.managerApi;

Vue.use(VueAxios, axios);
Vue.use(ElementUI, {
  size: 'small'
});
Vue.config.productionTip = false;

function refreshRouteTitle(to) {
  const brand = getBrand()
  if (to.path === '/login' || to.path.indexOf('/search') === 0) {
    applyDocumentTitle(to.meta && to.meta.title)
    return
  }
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - 下单系统 - ${brand}`
  } else {
    document.title = `下单系统 - ${brand}`
  }
}

//导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
      refreshRouteTitle(to)
       // 清除之前的meta标签
  const metas = document.querySelectorAll('meta[name="description"], meta[name="keywords"]');
  metas.forEach(meta => meta.parentNode.removeChild(meta));

  // 如果有新的meta信息，则添加
  if (to.meta.description) {
    const newMetaDescription = document.createElement('meta');
    newMetaDescription.name = 'description';
    newMetaDescription.content = to.meta.description;
    document.head.appendChild(newMetaDescription);
  }else {
    // 如果没有 description，则添加默认的 description
    const defaultDescriptionMeta = document.createElement('meta');
    defaultDescriptionMeta.name = 'description';
    defaultDescriptionMeta.content='公司主要做FBA海运专线，整柜直送，头程FBA，空运FBA，与COSCO和美森有长期签约，价格好，服务有保障'; // 这里替换成你的默认描述内容
    document.head.appendChild(defaultDescriptionMeta);
  };
  if (to.meta.keywords) {
    const newMetaKeywords = document.createElement('meta');
    newMetaKeywords.name = 'keywords';
    newMetaKeywords.content = to.meta.keywords;
    document.head.appendChild(newMetaKeywords);
  }  else {
    // 如果没有 keywords，则添加默认的 keywords
    const defaultKeywordsMeta = document.createElement('meta');
    defaultKeywordsMeta.name = 'keywords';
    defaultKeywordsMeta.content = '海运专线，空运专线，FBA专线，物流系统，货代系统'; // 这里替换成你的默认关键词
    document.head.appendChild(defaultKeywordsMeta);
  }


      // /search 公开查单长期保留（免登录）
      if (to.path === '/login' || to.path.indexOf('/search') == 0) {
        next();
        // 公开页拉取 sys_config.title（如「头程科技TMS内部系统」）后刷新标题
        ensureSysBrand().then(() => refreshRouteTitle(to))
      } else {
        let token = sessionStorage.getItem('token');
        if (!token) {
          next('/login');
        } else {
          refreshRouteTitle(to)
          next();
          ensureSysBrand().then(() => refreshRouteTitle(to))
        }
      }
})
  

// 全局过滤器，将时间戳格式化为日期字符串
Vue.filter('dateformat', function (unixNum, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (unixNum) {
    return moment.unix(unixNum).format(pattern)
  } else {
    return ''
  }
})

// 全局过滤器，将时间戳格式化为日期字符串
Vue.filter('dateformat1', function (unixNum, pattern = 'YYYY-MM-DD') {
  if (unixNum) {
    return moment.unix(unixNum).format(pattern)
  } else {
    return ''
  }
})


new Vue({
  router,
  store,
  created() {
    this.$store.dispatch('appTheme/initTheme')
  },
  render: h => h(App)
}).$mount("#app");